<!-- <script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
</script>
<template>
  <dashboard-layout currentRoute="consultations/list" page-title="Quản lý yêu cầu tư vấn">

  </dashboard-layout>
</template> -->


<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import _ from 'lodash'
import { computed, onMounted, watch } from 'vue'
import { ConsultationsListActionTypes, useConsultationsListStore } from '../stores/consultations.list.store'

interface Props {
  account?: object | undefined
  defautAction?: string | undefined
}

const props = defineProps<Props>()

const consultationListStore = useConsultationsListStore()

watch(() => props.defautAction, (newVal) => {
  consultationListStore.resetFilter()
  if (newVal === 'deposit') {
    consultationListStore.putFilter('type', 'deposit')
  } else if (newVal === 'withdraw') {
    consultationListStore.putFilter('type', 'withdrawal')
  }
}, { immediate: true })


const TableConfig = computed(() => {
  return consultationListStore.tableConfig
})
const filter = computed(() => {
  return consultationListStore.filter
})
const loading = computed(() => {
  return consultationListStore.action_type == ConsultationsListActionTypes.FETCHING
})
const page = computed(() => {
  return consultationListStore.page
})
const pageSize = computed(() => {
  return consultationListStore.pageSize
})
const dataSource = computed(() => {
  return consultationListStore.data
})

const handleChangePage = (page: number) => {

  consultationListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  consultationListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  consultationListStore.setFilter(filter)
}

const handleSort = (field: string, direction: string) => {

  consultationListStore.toggleSort(field, direction)
}

const requestFetchConsultationsList = _.debounce(async () => {
  try{
    const res = await consultationListStore.fetchList()
  } catch (e) {

  }
}, 500)

watch(()=> consultationListStore.uuid, (newVal, oldVal) => {
  requestFetchConsultationsList()
})

onMounted(() => {
  consultationListStore.resetFilter()

  if (props.account?.id) {
    consultationListStore.putFilter('account_id', props.account.id)
  }

  if (props.defautAction === 'deposit') {
    consultationListStore.putFilter('type', 'deposit')
  } else if (props.defautAction === 'withdraw') {
    consultationListStore.putFilter('type', 'withdrawal')
  }

})

const handleResetFilter = () => {

  consultationListStore.resetFilter()
}

</script>

<template>
  <dashboard-layout currentRoute="consultations/list" page-title="Quản lý yêu cầu tư vấn">
    <filter-list
      :filter="filter"
      @update:filter="handleUpdateFilter"
      v-if="!props.account"
      @reset:filter="handleResetFilter"
    />
    <data-table
      :loading="loading"
      :tableConfig="TableConfig"
      :page-size="pageSize"
      :page="page"
      :total-page="dataSource?.totalPage || 0"
      :total-records="dataSource?.totalRecords || 0"
      :data="dataSource?.list || []"
      primaryField="code"
      @page-changed="handleChangePage"
      @pagesize-changed="handleChangePageSize"
      @on-sort="handleSort"
    />
  </dashboard-layout>
</template>

<style scoped>

</style>
